import { Sheet } from '@ui'
import React, { FC, ReactNode } from 'react'

interface Props {
  visible?: boolean
  children?: ReactNode
  onBackdropClick?: () => void
  title?: string
}

/** Modal sheet with free-form content. Prefer `Sheet` from @ui for new code. */
const BottomSheet: FC<Props> = ({ visible, children, onBackdropClick, title }) => (
  <Sheet
    open={!!visible}
    onClose={onBackdropClick}
    dismissible={!!onBackdropClick}
    title={title ?? 'Details'}
    hideTitle={!title}
  >
    {children}
  </Sheet>
)

export default BottomSheet
